export default __webpack_public_path__ + "static/media/filter.d04f93e9.svg";